export default defineNuxtRouteMiddleware(to => {
  const { user: loggedUser } = useUserSession()

  if (to.path.includes('/admin')) {
    if (!loggedUser.value) {
      console.warn('The user is not logged in')
      return navigateTo('/sells')
    } else if (loggedUser.value.role !== 'admin') {
      console.warn('The user is not authorized to access the admin page')
      return navigateTo('/sells')
    }
  }
  return
})
